import { messageFormatter } from "../../message";
import Debug from "debug";
const debug = Debug("model:actions:walk.drinkPuddle");

const actionType = "DrinkPuddle";

const message = ({ gain }) => {
  let message = `nothing changes. still thirsty.`;
  if (gain.health > 0) {
    message = `the water's cool. feels good`;
  } else if (gain.health < 0) {
    message = `bitter taste. stomach churns`;
  }

  return messageFormatter(message, { gain });
};

const attempt = () => {
  // Introduce a probability factor for the outcome
  const isSafe = Math.random() < 0.6; // 60% chance the water is safe
  const hasNoEffect = Math.random() < 0.2; // 20% chance the water has no effect
  const healthChange = isSafe ? (hasNoEffect ? 0 : 1) : -2; // Gain health if safe, lose more if not

  const result = {
    success: isSafe,
    gain: {
      health: healthChange,
    },
  };

  debug(actionType, result);
  return result;
};

const executeSideEffects = (context, result) => {
  const { history, resources } = context.party;
  const { gain } = result;

  history.add({ action: actionType, result });
  resources.delta({ ...gain }, context);

  return { message: message(result) };
};

const drinkPuddle = (onDone) => ({
  title: "Drink",
  hotkey: "d",
  type: actionType,
  enabled: () => true,
  execute: (context) => {
    const result = attempt();
    const { message } = executeSideEffects(context, result);

    onDone();
    return { result: { message } };
  },
});

export default drinkPuddle;
